<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div style="margin-left: 45%; margin-bottom: 20px">
                <button
                  class="btn btn-primary btn-primary-add"
                  @click="AddUser"
                >
                  <i class="fas fa-plus" style="font-weight: 900"></i>
                </button>
                <h4
                  class="card-title"
                  style="display: inline-block; margin-right: 50%"
                >
                  قائمة المستخدمين
                </h4>
              </div>
            </template>
            <table
              class="table-hover table-striped tableStyle"
              style="width: 100%"
            >
              <thead>
                <tr>
                  <th
                    v-for="(column, index) in table1.columns"
                    :key="index"
                    :class="{ hiddenCol: column === 'الرقم التسلسلي' }"
                  >
                    {{ column }}
                  </th>
                  <th>الإجراءات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, rowIndex) in table1.data" :key="rowIndex">
                  <td class="hiddenCol">{{ row["الرقم التسلسلي"] }}</td>
                  <td v-html="row['الصورة الشخصية']"></td>
                  <td>{{ row["الاسم"] }}</td>
                  <td>{{ row["الدور"] }}</td>
                  <td>{{ row["رقم الهاتف"] }}</td>
                  <td class="email-cell">{{ row["البريد الإلكتروني"] }}</td>
                  <td>
                    <button
                      class="btn btn-primary btn-primary-add"
                      @click="editUser(row)"
                    >
                      <i class="fas fa-edit icon-primary"></i>
                    </button>
                    <button
                      class="btn btn-danger"
                      @click="deleteUser(row['الرقم التسلسلي'])"
                    >
                      <i class="fas fa-trash-alt icon-danger"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </card>
        </div>
      </div>
    </div>
    <nav v-if="table1.totalPages > 1">
      <ul class="pagination justify-content-center">
        <li
          class="page-item"
          v-for="page in table1.totalPages"
          :key="page"
          :class="{ active: table1.currentPage === page }"
        >
          <a class="page-link" @click="changePage(page)">{{ page }}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import Axios from "../../../Axios";
import LTable from "src/Dashboard/SharedComponents/Table.vue";
import Card from "src/Dashboard/SharedComponents/Card.vue";
import AddUser from "./AddUser";
import Swal from "sweetalert2";
import jwt_decode from "jwt-decode";

const tableColumns = [
  "الرقم التسلسلي",
  "الصورة الشخصية",
  "الاسم",
  "الدور",
  "رقم الهاتف",
  "البريد الإلكتروني",
];
export default {
  
  components: {
    LTable,
    Card,
    AddUser,
  },
  data() {
    return {
      table1: {
        columns: [...tableColumns],
        data: [],
        currentPage: 1,
        totalPages: 1,
        token: null,
        decodedToken: null,
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      Axios.get("/users", {
        params: {
          page: this.table1.currentPage,
          limit: 6,
        },
      })
        .then((response) => {
          // console.log(response.data.users);
          this.table1.data = response.data.users.map((user) => {
            return {
              "الرقم التسلسلي": user.id,
              الاسم: user.firstName + " " + user.lastName,
              الدور: user.role,
              "رقم الهاتف": user.phoneNumber ? user.phoneNumber : "-",
              "البريد الإلكتروني": user.email,
              "الصورة الشخصية": `<img src="https://jebsenboard.onrender.com/image/User/${user.image}" :alt="user.firstName" class="user-card-img" style="border-radius:10px;">`,
            };
          });
          this.table1.totalPages = response.data.totalPages;
        })
        .catch((error) => {
          // console.error(error);
        });
    },
    editUser(user) {
      this.$router.push({
        name: "edit-user",
        params: { id: user["الرقم التسلسلي"] },
        props: { userData: user },
      });
    },
    AddUser() {
      this.$router.push("/admin/add-user");
    },
    deleteUser(id) {
      // Show SweetAlert confirmation dialog before deletion
      Swal.fire({
        title: "هل أنت متأكد؟",
        text: "هل تريد حقًا حذف هذا المستخدم",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "نعم",
        cancelButtonText: "إلغاء",
        dangerMode: true,
      }).then((result) => {
        if (result.isConfirmed) {
          // The user clicked "نعم", perform the deletion
          Axios.delete(`/user/${id}`)
            .then((response) => {
              // If deletion is successful, update the table data
              this.table1.data = this.table1.data.filter(
                (row) => row["الرقم التسلسلي"] !== id
              );

              // Show success message using SweetAlert
              Swal.fire("تم الحذف!", "تم حذف المستخدم بنجاح.", "success");
            })
            .catch((error) => {
              // console.error(error);

              // Show error message using SweetAlert
              Swal.fire("خطأ!", "حدث خطأ أثناء الحذف.", "error");
            });
        }
      });
    },
    changePage(page) {
      this.table1.currentPage = page;
      this.fetchData();
    },
  },
  created() {
    this.token = localStorage.getItem("adminToken");
    this.decodedToken = this.token ? jwt_decode(this.token).role : null;
    if (this.decodedToken === "موظف") {
    this.$router.push("/admin/user");
  }
  },
};
</script>

<style>
.tableStyle {
  text-align: center;
}

.btn-primary-add {
  border: none;
  color: #007bff;
  font-weight: 800;
  font-size: 20px;
}

.btn-danger {
  border: none;
  color: #dc3545;
  font-weight: 800;
  font-size: 20px;
  margin-right: 3%;
}

.user-card-img {
  max-width: 100px;
}

.email-cell {
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pagination {
  margin-top: 10px;
}
</style>
